import { useAuth } from "@/context/AuthContext";
import { formatCZK } from "@/lib/format";
import { autoPill } from "@/components/shared/Pill";

// 281: typ spolupráce u sazby — podle něj ekonomika počítá, kolik člověk firmu stojí.
// HPP (i DPČ) = hrubá mzda + odvody firmy; DPP = bez odvodů do měsíčního limitu, nad ním
// z celé částky; na IČO = fakturuje, odvody a daně si platí sám.
export const CONTRACTS = [
  { value: "HPP", label: "HPP / DPČ", name: "Zaměstnanec", rateLabel: "Hrubá mzda" },
  { value: "DPP", label: "DPP", name: "Dohoda (DPP)", rateLabel: "Hrubá odměna" },
  { value: "ICO", label: "Na IČO", name: "Na IČO", rateLabel: "Cena za hodinu" },
];

export const contractOf = (v) => CONTRACTS.find((c) => c.value === v) || CONTRACTS[0];

export function laborTerms(company) {
  const pct = company?.labor_overhead_pct ?? 34.78;
  return { pct, coef: 1 + pct / 100, limit: company?.dpp_limit ?? 12000, pctText: String(pct).replace(".", ",") };
}

// Jedna věta pod volbou: co typ znamená a kolik člověk firmu stojí.
export function contractHint(contract, rate, company) {
  const t = laborTerms(company);
  const r = Number(rate) > 0 ? Number(rate) : null;
  if (contract === "DPP") return `Do ${formatCZK(t.limit)} za měsíc bez odvodů. Když si u vás vydělá víc, firma platí odvody ${t.pctText} % z celé částky.`;
  if (contract === "ICO") return `Fakturuje vám, odvody a daně si platí sám.${r ? ` Stojí vás ${formatCZK(r)}/h.` : " Stojí vás jen sazba."}`;
  return `Sazba je hrubá mzda, firma k ní platí odvody ${t.pctText} %.${r ? ` Stojí vás ${formatCZK(r * t.coef)}/h.` : ""}`;
}

export function ContractPicker({ value, onChange, rate, testid = "contract", className = "" }) {
  const { company } = useAuth();
  return (
    <div className={`min-w-0 ${className}`}>
      <div ref={autoPill} role="radiogroup" aria-label="Typ spolupráce" className="grid grid-cols-3 gap-1 p-1 rounded-[14px] bg-secondary">
        {CONTRACTS.map((c) => {
          const on = (value || "HPP") === c.value;
          return (
            <button key={c.value} type="button" role="radio" aria-checked={on} onClick={() => onChange(c.value)}
              data-testid={`${testid}-${c.value}`}
              className={`h-10 min-w-0 rounded-[11px] px-1 text-[14px] font-semibold truncate transition-colors motion-reduce:transition-none ${on ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}>
              {c.label}
            </button>
          );
        })}
      </div>
      <p className="text-[13px] text-muted-foreground mt-2 leading-snug" data-testid={`${testid}-hint`}>{contractHint(value || "HPP", rate, company)}</p>
    </div>
  );
}
